export default __webpack_public_path__ + "static/media/4.6dbe92b9.jpg";